import * as React from 'react';
import classnames from 'classnames';
import identity from 'lodash/identity';
import pickBy from 'lodash/pickBy';
import { Button } from '@grandvisionhq/common';
import { Form, Util } from '@grandvisionhq/forms';
import { logCreateAccountEvent } from '../../data-layer/create-account.js';
import { useSignUpFormSlots } from '../../slots/sign-up/SignUpFormSlotsContext.js';

const SignUpForm = ({ onSubmit , className , renderOptIns , isButtonLoading , buttonClass , buttonLabel , children ,  })=>{
    const { Slots: { form: FormTemplate  } ,  } = useSignUpFormSlots();
    const handleSubmit = (formState)=>{
        logCreateAccountEvent({
            type: 'create_account_click'
        });
        const formValues = Util.getValuesFromState(formState.formState);
        formValues.email && onSubmit(formValues.email, pickBy(formValues, identity));
    };
    if (!FormTemplate) {
        return null;
    }
    return /*#__PURE__*/ React.createElement(Form, {
        name: "signup-form",
        onSubmit: handleSubmit,
        className: classnames('signup-form', className)
    }, /*#__PURE__*/ React.createElement(FormTemplate, null), renderOptIns, /*#__PURE__*/ React.createElement(Button, {
        "data-t": "submit",
        type: "submit",
        isLoading: isButtonLoading,
        caption: buttonLabel,
        className: classnames('signup-form__button', buttonClass)
    }), children);
};

export { SignUpForm as default };
//# sourceMappingURL=SignUpForm.js.map
